module.exports = __webpack_public_path__ + "static/myrkul-symbol-SCAG-7e2ddd867fe687757ac48be9728bbe3c.png";